import SortIcon from '@mui/icons-material/Sort'
import { Box, Button, Collapse, TextField } from '@mui/material'
import { Sliders } from '@phosphor-icons/react'
import { useEffect, useState } from 'react'
import i18n from '../../../../lang/idiomas'
import DateFilter from './filters/DateFilter'
import WebPresupuestosSortBy from './WebPresupuestosSortBy'
/**
 * The PurchaseOrdersFilters component
 * @component
 *
 * @param {Object} props
 * @param {boolean} props.loader
 * @param {function} props.handleClick
  * @param {function} props.handleSortByChange
 * @param {boolean} props.selector_loading
 * @param {Array} props.purchasingOrganizations

 * @returns {JSX.Element}
 */

const WebPresupuestosFilters = ({ loader, handleClick, handleSortByChange }) => {
  const [expanded, setExpanded] = useState(false)
  const [expandedSort, setExpandedSort] = useState(false)

  const [id, setID] = useState('')
  const [fechaPedidoDesde, setFechaPedidoDesde] = useState('')
  const [fechaPedidoHasta, setFechaPedidoHasta] = useState('')
  const [ordenarPor, setOrdenarPor] = useState('')

  useEffect(() => {
    handleSortByChange(ordenarPor)
  }, [ordenarPor])

  return (
    <Box
      sx={{
        width: '100%',
      }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}>
        <Box sx={{ display: 'flex', gap: '8px', ml: 'auto' }}>
          <Button
            sx={{
              color: 'action.active',
              display: 'flex',
            }}
            endIcon={
              <Sliders
                size={30}
                weight={expanded ? 'fill' : 'light'}
              />
            }
            onClick={() => setExpanded(!expanded)}>
            {i18n.t('webpresupuestos.wpfbtnf')}
          </Button>
          <Button
            sx={{
              color: 'action.active',
              display: 'flex',
            }}
            endIcon={
              <SortIcon
                size={30}
                weight={expandedSort ? 'fill' : 'light'}
              />
            }
            onClick={() => setExpandedSort(!expandedSort)}>
            {i18n.t('webpresupuestos.wpfbtnsb')}
          </Button>
        </Box>
      </Box>
      <Collapse in={expandedSort}>
        <WebPresupuestosSortBy
          sortBy={ordenarPor}
          handleSortByChange={setOrdenarPor}
        />
      </Collapse>
      <Collapse in={expanded}>
        <Box
          component='form'
          noValidate
          autoComplete='off'
          sx={{
            display: 'flex',
            gap: '5px',
            flexDirection: 'column',
          }}>
          <TextField
            variant='outlined'
            label='ID'
            value={id}
            onChange={e => setID(e.target.value)}
            size='small'
            sx={{
              width: '50%',
            }}
          />
          <DateFilter
            handleDateFrom={setFechaPedidoDesde}
            handleDateUntil={setFechaPedidoHasta}
          />

          <Button
            disabled={loader}
            variant='contained'
            disableElevation
            sx={{
              ml: 'auto',
              my: 2,
              mb: 4,
              display: 'block',
              width: '100%',
              '&:disabled': {
                backgroundColor: 'lightgrey',
              },
            }}
            onClick={e => {
              e.preventDefault()
              handleClick(id, fechaPedidoDesde, fechaPedidoHasta, ordenarPor)
            }}>
            {i18n.t('webpresupuestos.wpfbtncn')}
          </Button>
        </Box>
      </Collapse>
    </Box>
  )
}

export default WebPresupuestosFilters
